<template>
  <footer :class="className"
   class="pk-flex">
    <div class="pk-page-spacing-flex"></div>
    <div class="pk-footer__left pk-flex">
      <div class="pk-flex__1">
        <template v-for="it of logoItems">
          <a :href="it.url"
           target="_blank"
           :key="it.title">
            <img :style="it.style"
             v-if="showLogo"
             :src="getIcons(it.img)">
            <span class="pk-footer__title"
             v-if="!showLogo"
             style="margin-right:15px">{{it.title}}</span>
          </a>
        </template>
      </div>
      <div class="pk-flex__00auto pk-flex"
       style="align-items: center;justify-content: flex-end; padding-bottom: 5px;">
        <router-link :to="about"><span class="pk-footer__title"
           style="margin:0; text-align: right;">{{about.title}}</span></router-link>
      </div>
    </div>
    <div class="pk-page-spacing-flex"></div>
    <div class="pk-footer__right pk-flex__1 pk-flex"
     style="padding-bottom: 5px;">
      <template v-for="it of rightNavList">
        <router-link :key="it.title"
         :to="it"><span class="pk-footer__title">{{it.title}}</span></router-link>
      </template>
    </div>
    <div class="pk-page-spacing-flex"></div>
  </footer>
</template>

<script>
import Vue from 'vue';
export default Vue.extend({
  data() {
    return {
      logoItems: [{
        img: 'kompetenz_logo_2016_neg.svg',
        title: 'Kompetenzzentrum',
        url: 'http://kompetenzzentrum.uni-trier.de/de/',
        style: 'height:35px; margin-top:15px'
      }, {
        img: 'Logo_Uni_Trier_typo_neg.svg',
        title: 'Uni Trier',
        url: 'http://www.uni-trier.de',
        style: 'height:20px; margin-top:10px; margin-left:20px'
      }, {
        img: 'screen1900_neg.svg',
        title: 'Screen1900/Medienwissenschaft',
        url: 'https://www.uni-trier.de/index.php?id=34034',
        style: 'height:20px; margin-top:10px; margin-left:20px'
      }, {
        img: 'illuminago_neg.svg',
        title: 'illuminago',
        url: 'http://www.illuminago.de/',
        style: 'height: 20px;margin-top:20px; margin-left:20px'
      }],
      about: {
        path: '/about',
        title: 'About eLaterna'
      },
      rightNavList: [
        {
          path: '/impressum',
          title: 'Impressum'
        },
        {
          path: '/datenschutz',
          title: 'Datenschutz'
        }
      ]
    };
  },
  computed: {
    className() {
      const p = this.$route.path;
      return(p === '/' || p === '/ea') ? 'pk-footer--home' : '';
    },
    showLogo() {
      const p = this.$route.path;
      return(p === '/' || p === '/ea');
    }
  },
  methods: {
    getIcons(name) {
      return this.$getIcon(name);
    }
  }
});
</script>

<style lang="scss">
@import '../assets/scss/footer.scss';

</style>